import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeDeleteKnowledgeBase } from "../../domain/use-cases/delete-knowledge-base"
import { httpKnowledgeBaseRepository } from "../../data/repositories/knowledge-base-repository"

const deleteKnowledgeBase = makeDeleteKnowledgeBase(httpKnowledgeBaseRepository)

export const useDeleteKnowledgeBase = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteKnowledgeBase(id),
    onSuccess: () =>
      void qc.invalidateQueries({
        queryKey: ["knowledge-bases"],
        refetchType: "all",
      }),
  })
}
